// <s-copy-code data-code="UUSI10"> copies its code to the clipboard when its
// [data-copy-button] is pressed, swaps the button label to the "copied" text
// for two seconds and announces the result politely. The code itself stays
// as selectable text, so copying works by hand where the Clipboard API is missing.
class SCopyCode extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-copy-button]');
    this.label = this.querySelector('[data-copy-label]');
    this.status = this.querySelector('[data-copy-status]');
    if (!this.button || !navigator.clipboard) {
      if (this.button) this.button.hidden = true;
      return;
    }
    this.onClick = this.copy.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
    clearTimeout(this.timer);
  }

  async copy() {
    const code = this.dataset.code;
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      return;
    }
    const idle = this.dataset.idleLabel;
    const done = this.dataset.doneLabel;
    if (this.label && done) this.label.textContent = done;
    if (this.status) this.status.textContent = this.dataset.announcement || done || '';
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.label && idle) this.label.textContent = idle;
      if (this.status) this.status.textContent = '';
    }, 2000);
  }
}

if (!customElements.get('s-copy-code')) customElements.define('s-copy-code', SCopyCode);
